<template>
  <div :class="$style.container"
       :style="containerStyle"
       @click="$emit('click')">
    <div :style="childContainerStyle">
      <div :style="leftContainerStyle">
        <div :style="suggestionContainerStyle">
          <template v-if="useTag">
            <SearchExpertBoxPopoverRowTag>
              <template v-slot:head>
                {{ suggestionHead }}
              </template>
              <template v-slot:body>
                {{ inputInSuggestion }}
              </template>
              <template v-slot:tail>
                {{ suggestionTail }}
              </template>
            </SearchExpertBoxPopoverRowTag>
          </template>
          <template v-else>
            <div :style="suggestionStyle">
              {{ suggestionHead }}
            </div>
            <div :style="inputStyle">
              {{ inputInSuggestion }}
            </div>
            <div :style="suggestionStyle">
              {{ suggestionTail }}
            </div>
          </template>
        </div>
        <div :style="textStyle">
          {{ text }}
        </div>
      </div>
      <div :style="rightContainerStyle">
        <IconSecondary :content="iconContent"
                       fontSize="20px"/>
      </div>
    </div>
  </div>
</template>

<script>
  import IconSecondary from '@modules/icon/icon-secondary'
  import SearchExpertBoxPopoverRowTag from '@modules/search-box/search-expert-box-popover-row-tag'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { splitString } from '@js/str-utils'

  export default {
    name: 'SearchExpertBoxPopoverRow',
    components: {
      IconSecondary,
      SearchExpertBoxPopoverRowTag,
    },
    props: {
      iconContent: { type: String, required: false, default: 'add' },
      input: { type: String, required: true },
      suggestion: { type: String, required: true },
      text: { type: String, required: false, default: 'by skill' },
      useTag: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        childContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
          width: '100%',
        },
        containerStyle: {
          cursor: 'pointer',
          height: '32px',
          width: '100%',
        },
        inputStyle: {
          fontWeight: FontStyle.weight.md,
        },
        leftContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          marginLeft: '16px',
        },
        rightContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          marginRight: '16px',
        },
        suggestionContainerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
        },
        suggestionStyle: {
          fontWeight: FontStyle.weight.xl,
        },
        textStyle: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.sm,
          fontStyle: 'italic',
          fontWeight: FontStyle.weight.md,
          padding: '0 0 0 8px',
        },
      };
    },
    created: function () {
      const prefix = '--search-expert-box-popover-row-container';

      this.containerStyle = {
        ...this.containerStyle,
        [`${prefix}-background-color`]: this.color.light1(),
        [`${prefix}-background-color-hover`]: this.color.dark6(),
        [`${prefix}-background-color-active`]: this.color.dark6(),
      };

      this.textStyle = {
        ...this.textStyle,
        color: this.color.dark3(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      suggestionHead: function () {
        return splitString(this.suggestion, this.input)[0];
      },
      inputInSuggestion: function () {
        return splitString(this.suggestion, this.input)[1];
      },
      suggestionTail: function () {
        return splitString(this.suggestion, this.input)[2];
      },
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--search-expert-box-popover-row-container-background-color)
    &:hover
      background-color var(--search-expert-box-popover-row-container-background-color-hover)
    &:active
      background-color var(--search-expert-box-popover-row-container-background-color-active)
</style>

